/**
 * cart-free-gift.js — Final Version (immediate gift visibility fix only)
 */
 
(function () {
  const AJ_GIFT = window.AJ_GIFT || null;
  if (!AJ_GIFT || !AJ_GIFT.options || !AJ_GIFT.options.length) {
    console.warn('[FreeGift] No AJ_GIFT config found');
    return;
  }
  const THRESHOLD_CENTS = Number(AJ_GIFT.thresholdCents) || 100000;
  const LEGACY_VARIANT_ID = Number(AJ_GIFT.legacyVariantId) || 0;
  const GIFT_VARIANT_IDS = AJ_GIFT.options.map(o => Number(o.variantId));
  const ALL_GIFT_IDS = LEGACY_VARIANT_ID ? GIFT_VARIANT_IDS.concat([LEGACY_VARIANT_ID]) : GIFT_VARIANT_IDS.slice();

  console.log('[FreeGift] Loaded, gift choice variants:', GIFT_VARIANT_IDS, '| threshold cents:', THRESHOLD_CENTS);
 
  let reAddTimer = null;
  let isSyncing = false;
  let isAddingGift = false;
  let isRemovingGift = false;
  
  /* ── Fetch cart ───────────────────────────────────── */
 
  async function fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return res.json();
  }
 
  /* ── Add a chosen gift (Claim button only — never auto-added) ── */

  async function addGiftVariant(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _free_gift: 'true'
          }
        }]
      })
    });
    return res.json();
  }

  async function claimGift(variantId, btn) {
    if (isAddingGift || isRemovingGift) return;
    if (!GIFT_VARIANT_IDS.includes(Number(variantId))) return;

    console.log('[FreeGift] Claiming gift variant:', variantId);
    isAddingGift = true;
    if (btn) btn.disabled = true;

    try {
      const data = await addGiftVariant(Number(variantId));
      console.log('[FreeGift] Claim response:', data);

      if (data.status && data.status !== 200) {
        console.warn('[FreeGift] Claim error:', data.description || data.message);
        return;
      }

      // Small delay to ensure cart is updated
      await new Promise(resolve => setTimeout(resolve, 200));

      // Force immediate UI update without closing drawer
      await refreshCartUI(true);

      const cart = await fetchCart();
      updateProgressBar(stateFromCart(cart));

    } catch (e) {
      console.warn('[FreeGift] Claim error:', e);
    } finally {
      setTimeout(() => {
        isAddingGift = false;
        if (btn) btn.disabled = false;
      }, 500);
    }
  }

  function bindClaimButtons() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-gift-add]');
      if (!btn) return;
      e.preventDefault();
      claimGift(Number(btn.getAttribute('data-gift-add')), btn);
    });
  }

  /* ── Remove gift ──────────────────────────────────── */
  
  async function removeGiftFromCart(lineKey) {
    if (isRemovingGift) return;
    
    console.log('[FreeGift] Removing gift...');
    isRemovingGift = true;
    
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });
      
      await refreshCartUI(true);
      try {
        const cartAfterRemove = await fetchCart();
        updateProgressBar(stateFromCart(cartAfterRemove));
      } catch (e) {}
      
    } catch (e) {
      console.warn('[FreeGift] Remove error:', e);
    } finally {
      setTimeout(() => {
        isRemovingGift = false;
      }, 300);
    }
  }
 
  /* ── Clean gift properties ────────────────────────── */
 
  async function cleanGiftProperties() {
    try {
      const cart = await fetchCart();
      const giftLine = giftLineInCart(cart);
      if (!giftLine) return;
 
      const extraProps = Object.keys(giftLine.properties || {}).filter(
        k => k !== '_free_gift'
      );
 
      if (extraProps.length === 0) return;
 
      console.log('[FreeGift] Stray properties found on gift, cleaning:', extraProps);
 
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 })
      });
 
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftLine.variant_id,
            quantity: 1,
            properties: {
              _free_gift: 'true'
            }
          }]
        })
      });
 
      const data = await res.json();
      console.log('[FreeGift] Clean re-add response:', data);
 
    } catch (e) {
      console.warn('[FreeGift] Clean properties error:', e);
    }
  }
 
  /* ── Update cart count UI ─────────────────────────── */
  function updateCartCountUI(cart) {
    if (!cart) return;

    const totalCount = cart.item_count || 0;

    document.querySelectorAll(
      '[data-cart-count], .cart-count, .cart-count-bubble, .header__cart-count, .cart-icon-bubble'
    ).forEach((el) => {
      el.textContent = totalCount;
      el.setAttribute('data-cart-count', totalCount);
      el.classList.toggle('hidden', totalCount === 0);
      el.classList.toggle('is-hidden', totalCount === 0);
    });

    document.querySelectorAll('.cart-count-bubble span, .cart-icon-bubble span').forEach((el) => {
      el.textContent = totalCount;
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
  }

  /* ── Refresh cart UI - FIXED for immediate gift visibility ── */
  
  async function refreshCartUI(forceUpdate = false) {
    console.log('[FreeGift] Refreshing cart UI...');

    const cart = await fetchCart();
    updateCartCountUI(cart);

    // Cart page — just reload
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    const cartComponent = document.querySelector('cart-drawer-component');
    if (!cartComponent) {
      console.warn('[FreeGift] No cart-drawer-component found');
      return;
    }

    // Find section ID
    const sectionEl = cartComponent.closest('[id^="shopify-section"]');
    const sectionId = sectionEl?.id?.replace('shopify-section-', '');

    if (sectionId) {
      console.log('[FreeGift] Fetching section:', sectionId);
      try {
        const res = await fetch(`/?sections=${encodeURIComponent(sectionId)}`, {
          cache: 'no-store'
        });

        if (res.ok) {
          const json = await res.json();
          const html = json[sectionId];

          if (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Try different selectors to find the cart content
            const newContent = 
              doc.querySelector('.cart-drawer__content') ||
              doc.querySelector('.cart-items__wrapper') ||
              doc.querySelector('[data-cart-items]') ||
              doc.querySelector('.cart__items');

            const oldContent = 
              cartComponent.querySelector('.cart-drawer__content') ||
              cartComponent.querySelector('.cart-items__wrapper') ||
              cartComponent.querySelector('[data-cart-items]') ||
              cartComponent.querySelector('.cart__items');

            if (newContent && oldContent) {
              // Store scroll position
              const scrollTop = oldContent.scrollTop;
              oldContent.innerHTML = newContent.innerHTML;
              // Restore scroll position
              if (scrollTop) oldContent.scrollTop = scrollTop;
              
              console.log('[FreeGift] ✅ Cart drawer content updated - gift should be visible');
              
              // Also update any cart summary/totals
              const newSummary = doc.querySelector('.cart-drawer__summary, .cart__summary, .cart-totals');
              const oldSummary = cartComponent.querySelector('.cart-drawer__summary, .cart__summary, .cart-totals');
              if (newSummary && oldSummary) {
                oldSummary.innerHTML = newSummary.innerHTML;
              }
              
              // Dispatch events to notify other components
              const event = new CustomEvent('cart:section-updated', { 
                detail: { sectionId, cart } 
              });
              document.dispatchEvent(event);
              
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
              document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
              
              return true;
            }
          }
        }
      } catch (e) {
        console.warn('[FreeGift] Section fetch failed:', e);
      }
    }
    
    // Fallback: Force cart component to update via its own methods
    if (cartComponent && typeof cartComponent.updateCart === 'function') {
      cartComponent.updateCart();
    }
    
    // Dispatch event to trigger any cart update listeners
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
    
    return false;
  }
 
  /* ── Helpers ──────────────────────────────────────── */
 
  function isGiftItem(item) {
    return ALL_GIFT_IDS.includes(item.variant_id) &&
      item.properties &&
      item.properties._free_gift === 'true';
  }

  function giftLineInCart(cart) {
    return cart.items.find(isGiftItem);
  }

  function legacyLineInCart(cart) {
    if (!LEGACY_VARIANT_ID) return null;
    return cart.items.find(
      item =>
        item.variant_id === LEGACY_VARIANT_ID &&
        item.properties &&
        item.properties._free_gift === 'true'
    );
  }

  function qualifyingSubtotalCents(cart) {
    return cart.items.reduce((sum, item) => {
      return isGiftItem(item) ? sum : sum + (item.final_line_price ?? item.line_price ?? 0);
    }, 0);
  }

  function isQualified(cart) {
    return qualifyingSubtotalCents(cart) >= THRESHOLD_CENTS;
  }

  function stateFromCart(cart) {
    const subtotal = qualifyingSubtotalCents(cart);
    return {
      qualified: subtotal >= THRESHOLD_CENTS,
      subtotalCents: subtotal,
      hasGift: !!giftLineInCart(cart)
    };
  }

  function formatMoney(cents) {
    const v = cents / 100;
    const str = Number.isInteger(v)
      ? v.toLocaleString('en-US')
      : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + str;
  }

  /* ── Progress bar ─────────────────────────────────── */
 
  function updateProgressBar(state) {
    const bars      = document.querySelectorAll('.iv-gift-progress__fill');
    const msgs      = document.querySelectorAll('.iv-gift-progress__msg');
    const unlockeds = document.querySelectorAll('.iv-gift-progress__unlocked');
    const choices   = document.querySelectorAll('.aj-gift-choice, #aj-gift-choice');
    if (!bars.length) return;

    const pct = Math.min(100, (state.subtotalCents / THRESHOLD_CENTS) * 100);
    bars.forEach(bar => { bar.style.width = pct + '%'; });

    const showChoice = state.qualified && !state.hasGift;
    choices.forEach(el => { el.hidden = !showChoice; });

    if (state.qualified && state.hasGift) {
      msgs.forEach(msg => { msg.style.display = 'none'; });
      unlockeds.forEach(u => { u.style.display = 'flex'; });
    } else if (state.qualified) {
      msgs.forEach(msg => { msg.style.display = 'block'; msg.textContent = 'Choose your free gift below'; });
      unlockeds.forEach(u => { u.style.display = 'none'; });
    } else {
      unlockeds.forEach(u => { u.style.display = 'none'; });
      msgs.forEach(msg => {
        msg.style.display = 'block';
        msg.textContent = state.subtotalCents === 0
          ? 'Free gift on orders $1,000+'
          : "You're " + formatMoney(THRESHOLD_CENTS - state.subtotalCents) + ' away from a free gift';
      });
    }
  }

  /* ── Core sync ────────────────────────────────────── */
 
  async function syncFreeGift() {
    if (isSyncing || isAddingGift || isRemovingGift) return;
    isSyncing = true;

    try {
      let cart = await fetchCart();

      // Legacy single gift is replaced by the choice: remove it regardless.
      const legacyLine = legacyLineInCart(cart);
      if (legacyLine && !isRemovingGift) {
        isSyncing = false;
        await removeGiftFromCart(legacyLine.key);
        await new Promise(resolve => setTimeout(resolve, 350));
        isSyncing = true;
        cart = await fetchCart();
      }

      const giftLine  = giftLineInCart(cart);
      const subtotal  = qualifyingSubtotalCents(cart);
      const qualified = subtotal >= THRESHOLD_CENTS;

      console.log('[FreeGift] subtotal cents:', subtotal, '| gift in cart:', !!giftLine, '| qualified:', qualified);

      updateProgressBar({ qualified, subtotalCents: subtotal, hasGift: !!giftLine });

      if (!qualified && giftLine && !isRemovingGift) {
        isSyncing = false;
        await removeGiftFromCart(giftLine.key);
        return;
      }

      if (qualified && giftLine) {
        const extraProps = Object.keys(giftLine.properties || {}).filter(
          k => k !== '_free_gift'
        );
        if (extraProps.length > 0) {
          console.log('[FreeGift] Sync: found dirty gift, cleaning...');
          await cleanGiftProperties();
          await refreshCartUI(true);
          const fresh = await fetchCart();
          updateProgressBar(stateFromCart(fresh));
        }
      }
      // qualified && !giftLine: do NOT auto-add — reveal the choice UI only
      // (updateProgressBar above unhides #aj-gift-choice).
    } catch (e) {
      console.warn('[FreeGift] Sync error:', e);
    } finally {
      setTimeout(() => {
        isSyncing = false;
      }, 300);
    }
  }

  /* ── Intercept fetch ──────────────────────────────── */
 
  function interceptFetch() {
    const originalFetch = window.fetch;
 
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
 
      const isCartAdd = url.includes('/cart/add') && !isSyncing && !isAddingGift;
      const isCartChange = (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) && !isSyncing;
      const isCartRemove = url.includes('/cart/change') && args[1]?.body?.includes('quantity=0');
 
      if (isCartAdd || isCartChange) {
        console.log('[FreeGift] Cart event detected:', url);
        const clone = response.clone();
        
        // Shorter delay for add events to make gift appear faster
        const delay = isCartAdd ? 200 : (isCartRemove ? 100 : 500);
        
        clone.json()
          .then(() => {
            clearTimeout(reAddTimer);
            reAddTimer = setTimeout(syncFreeGift, delay);
          })
          .catch(() => {
            clearTimeout(reAddTimer);
            reAddTimer = setTimeout(syncFreeGift, delay);
          });
      }
 
      return response;
    };
  }
 
  /* Batch 8.5: while the cart drawer opens/closes its animation fights the
   polling fetch + re-render underneath it (the ~2.8 s phone drawer cost).
   Watch the drawer dialog's open state; pause polling through the animation
   window (700 ms grace) after every toggle. */
  var ajDrawerAnimatingUntil = 0;
  (function ajWatchCartDrawer() {
    var dlg = document.querySelector('cart-drawer-component dialog');
    if (!dlg) return;
    new MutationObserver(function () {
      ajDrawerAnimatingUntil = Date.now() + 700;
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  })();

  /* ── Poll every 3 seconds as safety net ──────────── */
 
  function startPolling() {
    setInterval(async () => {
      if (isSyncing || isAddingGift || isRemovingGift) return;
      if (Date.now() < ajDrawerAnimatingUntil) return; // Batch 8.5: drawer animating
      try {
        const cart      = await fetchCart();
        const giftLine  = giftLineInCart(cart);
        const legacy    = legacyLineInCart(cart);
        const qualified = isQualified(cart);
 
        updateProgressBar(stateFromCart(cart));
 
        if (legacy && !isRemovingGift) {
          console.log('[FreeGift] Poll: legacy gift present, replacing with choice');
          clearTimeout(reAddTimer);
          reAddTimer = setTimeout(syncFreeGift, 200);
        } else if (!qualified && giftLine && !isRemovingGift) {
          console.log('[FreeGift] Poll: gift should be removed');
          clearTimeout(reAddTimer);
          reAddTimer = setTimeout(syncFreeGift, 200);
        }
        // qualified && !giftLine: choice UI only - never auto-add.
      } catch (e) {}
    }, 3000);
  }
 
  /* ── Cart events ──────────────────────────────────── */
 
  function listenToCartEvents() {
    ['cart:updated', 'cart-update', 'cart:change', 'cart:refresh'].forEach(name => {
      document.addEventListener(name, () => {
        if (!isSyncing && !isAddingGift && !isRemovingGift) {
          clearTimeout(reAddTimer);
          reAddTimer = setTimeout(syncFreeGift, 300);
        }
      });
    });
  }
  
  /* ── Listen for cart drawer open ────────────────── */
  function listenForCartDrawer() {
    const cartComponent = document.querySelector('cart-drawer-component');
    if (cartComponent) {
      // Listen for dialog open event
      cartComponent.addEventListener('DialogOpenEvent', async () => {
        if (!isSyncing && !isAddingGift && !isRemovingGift) {
          const cart = await fetchCart();
          updateProgressBar(stateFromCart(cart));
          await syncFreeGift();
          // The drawer component may re-render its section HTML right after
          // opening, wiping JS-applied bar/choice state — re-apply shortly after.
          [900, 1800].forEach(ms => setTimeout(async () => {
            try {
              const c = await fetchCart();
              updateProgressBar(stateFromCart(c));
            } catch (e) {}
          }, ms));
        }
      });
    }
  }
 
  /* ── Init ─────────────────────────────────────────── */
 
  async function init() {
    console.log('[FreeGift] Initializing...');
 
    interceptFetch();
    listenToCartEvents();
    listenForCartDrawer();
    bindClaimButtons();
    startPolling();
    
    const cart = await fetchCart();
    updateProgressBar(stateFromCart(cart));
    
    await syncFreeGift();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();